/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "assets/js/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _image_loader = __webpack_require__(6);
	
	var _image_loader2 = _interopRequireDefault(_image_loader);
	
	var _eager_loader = __webpack_require__(7);
	
	var _eager_loader2 = _interopRequireDefault(_eager_loader);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var $ = __webpack_require__(2),
	    TweenMax = __webpack_require__(3);
	
	var indexjs = null;
	
	var logSize = function logSize() {
	    var s = window.innerWidth + ' x ' + window.innerHeight;
	    $('#current-size').html(s);
	};
	/*
	logSize();
	$(window).resize(logSize);
	*/
	
	var loading = function loading(d) {
	    // load svg
	    var $app = $('#app');
	    var $intro = $('#intro-frame');
	    //var $turnHint = $('.turn-screen-hint').hide();
	    var svgPromise = new $.Deferred();
	
	    $intro.css({
	        // background: '#fff'
	    });
	
	    var intervals = [];
	
	    // load intro objects
	    var images = [{
	        url: './assets/imgs/loading-1.svg',
	        callback: function callback(response) {
	            var svgDOM = response.getElementsByTagName('svg');
	            var $svg = $(svgDOM);
	            $svg.attr({
	                id: 'loading-1',
	                class: 'bg bg-frame'
	            }).appendTo($intro);
	            $('#intro-frame text').html('<span style="visibility:hidden"> 0</span>0%');
	            $('#fire-pre').hide();
	            var toggleCracker = function toggleCracker(off_fire, on_fire) {
	                $(off_fire).hide();
	                $(on_fire).show();
	            };
	            $('#fire-2,#fire-3,#fire-4,#fire-5,#fire-6,#fire-7,#fire-8,#fire-9').hide();
	            var t = 100;
	            var theInterval = setInterval(function () {
	                // setTimeout(toggleCracker.bind(this, '#fire-1', '#fire-2'), 0);
	                // setTimeout(toggleCracker.bind(this, '#fire-2', '#fire-3'), t);
	                // setTimeout(toggleCracker.bind(this, '#fire-3', '#fire-4'), t * 2);
	                // setTimeout(toggleCracker.bind(this, '#fire-4', '#fire-1'), t * 4);
	                for (var i = 0; i < 8; i++) {
	                    setTimeout(toggleCracker.bind(this, '#fire-' + (i + 1), '#fire-' + (i + 2)), t * i);
	                }
	                setTimeout(toggleCracker.bind(this, '#fire-9', '#fire-1'), t * 8);
	            }, t * 10);
	            intervals.push(theInterval);
	        }
	    }, {
	        url: './assets/imgs/loading-2.svg',
	        callback: function callback(response) {
	            var $object = $(response.getElementsByTagName('svg'));
	            $object.appendTo($intro).attr({
	                id: 'loading-2',
	                class: 'bg bg-frame'
	            }).hide();
	        }
	    }];
	    var introLoaderCallback = function introLoaderCallback() {};
	
	    var introLoader = new _image_loader2.default(images);
	    var introPromise = introLoader.promise;
	
	    introPromise.done(introLoaderCallback);
	
	    var svgs = [];
	
	    introPromise.done(function () {
	        var images = [{
	            url: './assets/imgs/mazu_background.svg',
	            callback: function callback(response) {
	                var svg = response.getElementsByTagName('svg');
	                var $svg = $(svg).attr({
	                    type: "image/svg+xml",
	                    id: "main-background",
	                    class: "bg bg-parade"
	                });
	                svgs.push({
	                    target: $app,
	                    dom: $svg
	                });
	            }
	        }, {
	            url: localStorage["mazu_language"] === "en" ? './assets/imgs/english-svg/panel.svg' : './assets/imgs/panel.svg',
	
	            callback: function callback(response) {
	                var svg = response.getElementsByTagName('svg');
	                var $svg = $(svg).attr({
	                    type: "image/svg+xml",
	                    id: localStorage["mazu_language"] === "en" ? 'panel-english' : 'panel',
	
	                    class: "bg bg-parade"
	                });
	                svgs.push({
	                    target: $app,
	                    dom: $svg
	                });
	            }
	        }];
	
	        var $main_parade = $('#main-parade');
	        var image_prefix = './assets/imgs/parade/';
	
	        var platform = navigator.platform;
	
	        if (platform.match(/(Linux)|(iPhone)/i)) {
	            image_prefix += 'tiny/';
	        } else if (platform.match(/(iPad)/i)) {
	            image_prefix += 'small/';
	        } else if (platform.match(/(Mac)|(Win)/i)) {
	            image_prefix += 'normal/';
	        } else {
	            var size = window.innerWidth * window.innerHeight;
	
	            if (size <= 600 * 600) {
	                image_prefix += 'tiny/';
	            } else if (size <= 900 * 900) {
	                image_prefix += 'small/';
	            } else {
	                image_prefix += 'normal/';
	            }
	        }
	
	        var _loop = function _loop(_i) {
	            var index = '' + _i;
	            if (_i < 10) {
	                index = '0' + index;
	            }
	            images.push({
	                url: localStorage["mazu_language"] === "en" ? './assets/imgs/english-svg/g-' + index + '.svg' : './assets/imgs/svg/g-' + index + '.svg',
	                callback: function callback(response) {
	                    var svg = response.getElementsByTagName('svg');
	                    var $svg = $(svg);
	                    $svg.attr({
	                        type: 'image/svg+xml',
	                        'class': 'group group-' + _i
	                    });
	                    var actions = $svg.find('image');
	
	                    actions.each(function (index, dom) {
	                        var origin_image_name = dom.getAttribute('xlink:href');
	                        dom.setAttribute('xlink:href', '' + image_prefix + origin_image_name);
	                        dom.setAttribute('class', 'action action-' + (index + 1));
	                    });
	
	                    // let $div = $('<div>')
	                    //   .append($svg)
	                    //   .attr({
	                    //     'class': 'group group-' + i
	                    //   })
	                    //   ;
	
	                    $main_parade.append($svg);
	                }
	            });
	        };
	
	        for (var _i = 1; _i <= 14; _i++) {
	            _loop(_i);
	        }
	
	        var eagerLoader = new _eager_loader2.default();
	
	        for (var i = 0; i < eagerLoader.urls.length; i++) {
	            var url = eagerLoader.urls[i];
	            images.push({
	                url: url,
	                callback: function callback() {}
	            });
	        }
	
	        var appImageLoader = new _image_loader2.default(images, function (loader) {
	            var count = loader.loadedImage;
	            count = Math.ceil(count * 100 / loader.images.length);
	            count += '%';
	            if (count.length <= 2) {
	                count = '0'.count;
	            }
	            $('#intro-frame text').html(count);
	        });
	
	        appImageLoader.promise.done(function () {
	            $app.hide();
	            eagerLoader.convert();
	            var height = $('#loading-1')[0].height.animVal.value * 0.60;
	            setTimeout(function () {
	                for (var i = 0; i < intervals.length; i++) {
	                    clearInterval(intervals[i]);
	                }
	            }, 1000);
	            var progressHint = new TimelineMax();
	            $('#intro-frame text').remove();
	            svgPromise.resolve();
	            setTimeout(function () {
	                progressHint.to($('#fire-all'), 0.7, { yPercent: -107 }, 'c2');
	            }, 1500);
	            setTimeout(function () {
	                $('#loading-2').fadeIn(200);
	            }, 2400);
	            /*
	            var $clickBoard = $('<div>')
	            .css({
	                position: 'fixed',
	                top: 0,
	                left: 0,
	                width: '100vw',
	                height: '100vh',
	                background: '#ccc',
	                opacity: 0,
	                'z-index': 9999999999,
	            })
	            .appendTo(document.body)
	            ;
	            */
	
	            $('#enter-button').one('click', function () {
	
	                for (var i = 0; i < svgs.length; i++) {
	                    var svg = svgs[i];
	                    svg.target.append(svg.dom);
	                }
	
	                (function (d, s, id) {
	                    var js,
	                        fjs = d.getElementsByTagName(s)[0];
	
	                    if (localStorage["mazu_language"] === "en") {
	                        $('#container').addClass('english');
	                    }
	
	                    if (d.getElementById(id)) return;
	                    js = d.createElement(s);js.id = id;
	                    js.src = "./assets/js/index.js";
	                    fjs.parentNode.insertBefore(js, fjs);
	                    js.onload = function () {
	                        $intro.fadeOut(function () {
	                            $app.fadeIn(function () {
	                                $('.main-parade').show();
	                                $('#main-container').show();
	                            });
	                            $intro.remove();
	                        });
	                    };
	                })(document, 'script', 'index-js');
	                ;
	            });
	
	            //$clickBoard.click();
	
	            /*
	            for (let i = 1; i <= 13; i++ ) {
	                setTimeout(function(){
	                $('#contents-' + i).click()
	                }, i * 1600 + 1200);
	             }
	            */
	        });
	    });
	};
	
	var isLandscape = function isLandscape() {
	    return window.innerHeight <= innerWidth;
	};
	
	var enter = function enter() {
	    $('.language-selection').fadeOut(500);
	    if (isLandscape()) {
	        loading(document);
	        ga('send', 'event', 'Position', 'pass', 'loading game');
	    } else {
	        $(window).resize(function (event) {
	            if (isLandscape()) {
	                $(window).off('resize');
	                loading(document);
	                ga('send', 'event', 'Position', 'pass', 'loading game');
	            }
	        });
	    }
	};
	
	$("#enter-zh-tw").click(function () {
	    localStorage['mazu_language'] = 'zh-tw';
	    enter();
	});
	
	$("#enter-en").click(function () {
	    localStorage['mazu_language'] = 'en';
	    enter();
	});
	
	// if (isLandscape()) {
	//     loading(document);
	//     ga('send', 'event', 'Position', 'pass', 'loading game')
	// } else {
	//     $(window).resize(function (event) {
	//         if (isLandscape()) {
	//             $(window).off('resize');
	//             loading(document);
	//             ga('send', 'event', 'Position', 'pass', 'loading game')
	//         }
	//     });
	// }

/***/ },
/* 1 */,
/* 2 */
/***/ function(module, exports) {

	module.exports = jQuery;

/***/ },
/* 3 */
/***/ function(module, exports) {

	module.exports = TweenMax;

/***/ },
/* 4 */,
/* 5 */,
/* 6 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var ImageLoader = function () {
	    function ImageLoader(images, onDone) {
	        _classCallCheck(this, ImageLoader);
	
	        this.images = images;
	        this.loadedImage = 0;
	        this.promise = new $.Deferred();
	        this.onDone = onDone;
	        this.load();
	    }
	
	    _createClass(ImageLoader, [{
	        key: 'load',
	        value: function load() {
	            var previousDefers = [];
	            for (var i = 0; this.images[i]; i++) {
	                var image = this.images[i];
	                var url = image.url;
	                var callback = image.callback;
	                var currentDefer = $.get({
	                    url: url,
	                    success: function (response, b) {
	                        this.loadedImage++;
	                        if (this.images.length === this.loadedImage) {
	                            this.promise.resolve();
	                        }
	                    }.bind(this)
	                }).done(function (url, loader) {
	                    var thisUrl = url;
	                    return function (response) {
	                        if (loader.onDone && typeof loader.onDone === 'function') {
	                            loader.onDone(loader);
	                        }
	                    };
	                }(url, this));
	
	                if (previousDefers.length === 0) {
	                    currentDefer.done(callback);
	                } else {
	                    var _$;
	
	                    (_$ = $).when.apply(_$, previousDefers).done(currentDefer.done(callback));
	                }
	                previousDefers.push(currentDefer);
	            }
	        }
	    }]);
	
	    return ImageLoader;
	}();
	
	exports.default = ImageLoader;

/***/ },
/* 7 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	var EagerLoader = function () {
	    function EagerLoader() {
	        _classCallCheck(this, EagerLoader);
	
	        this.targets = $('img[data-src]');
	        this.urls = [];
	        this.targets.each(function (id, target) {
	            var $target = $(target);
	            this.urls.push($target.data('src'));
	        }.bind(this));
	    }
	
	    _createClass(EagerLoader, [{
	        key: 'convert',
	        value: function convert() {
	            $('img[data-src]').each(function (id, target) {
	                var $target = $(target);
	                var src = $target.data('src');
	                $target.attr({
	                    src: src
	                });
	                $target.removeAttr('data-src');
	            });
	        }
	    }]);
	
	    return EagerLoader;
	}();
	
	exports.default = EagerLoader;

/***/ }
/******/ ]);


/** WEBPACK FOOTER **
 ** intro.js
 **/